const PROJECTS_DATA = [
  {
    title: "Runic Vault",
    description:
      "A modern ERP platform for buying and selling games with a seamless payment experience.",
    about:
      "RunicVault is a gaming marketplace where users can explore, purchase, and manage their favorite games. Built with a powerful backend and dynamic frontend, RunicVault serves as an e-commerce platform for games. Sellers can upload their game listings, while administrators manage the platform, ensuring quality control and security.",
    link: "https://runic-vault.vercel.app/",
    imageUrl: "../images/runic-vault.png",
    github: "https://github.com/Anupreet1213/RunicVault",
    type: ["project", "open-source", "tools"],
    technologies: ["React", "Node JS", "Express", "MongoDB", "Stripe"],
  },
  {
    title: "Reclaim Green - Carbon Emission Predictor",
    description: "Calculate your carbon emissions",
    about:
      "Reclaim Green calculate carboon footprints on individual and industry level. The project uses React for the UI part and Backend is based upon Machine Learning that trains dataset for calculating the carbon emissions. The project uses Firestore database as well to store user data and display their past footprints.  ",
    link: "https://github.com/AmanApT/CEmission",
    // imageUrl: "../images/CEmissionImage.webp",
    imageUrl: "../images/gif2.gif",
    github: "https://github.com/AmanApT/CEmission",
    type: ["project", "open-source", "tools"],
    technologies: [
      "React",
      "Machine Learning",
      "Firestore Database",
      "User Authentication System",
      "Random Forest",
    ],
  },
  {
    title: "Adest - All format converter",
    description: "Adest provide free of cost file conversion service",
    about:
      "Adest provide free of cost file conversion service, enabling multiple conversions and compressions at once, saves users significant time and costs.",
    link: "https://adest.vercel.app/",
    // imageUrl: "../images/adest.webp",
    imageUrl: "../images/gif.gif",
    github: "https://github.com/AmanApT/adest",
    type: ["project", "open-source", "tools"],
    technologies: ["Next JS", "TypeScript", "MUI"],
  },
];

export default PROJECTS_DATA;
